import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Product } from '@core/model/product.model';
import { Warehouse } from '@core/model/warehouse.model';
import { ProductService, WarehouseService } from '@app/core';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warehouse-create',
  templateUrl: './warehouse-create.component.html',
  styleUrls: ['./warehouse-create.component.css']
})
export class WarehouseCreateComponent implements OnInit {
  warehouseForm: FormGroup;
  products: Product[];
  warehouses: Warehouse[];
  isLoading = false;

  @Input() almacen_id: string;
  @Input() estado: boolean;
  @Input() titulo: string;

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private warehouseService: WarehouseService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.createForm();
    this.listProducts();
    // this.listWarehouse();

    if (this.estado === true) {
      this.warehouseService.getById(this.almacen_id).subscribe(data => {
        console.log(data);
        // this.categoryForm.setValue(data);
        this.warehouseForm.setValue({
          producto_id: data.producto_id,
          cantidad: data.cantidad,
          precio_compra: data.costo_compra,
          nro_comprobante: data.nro_comprobante,
          fecha_ingreso: data.fecha_ingreso
        });
      });
    }
  }

  createForm() {
    this.warehouseForm = this.formBuilder.group({
      cantidad: ['', [Validators.required]],
      fecha_ingreso: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      precio_compra: ['', [Validators.required]],
      nro_comprobante: [''],
      producto_id: ['', [Validators.required]]
    });
  }

  listProducts() {
    this.productService.getProductosAlmacen().subscribe(
      date => {
        this.products = date;
        console.log(date);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  listWarehouse() {
    this.warehouseService.getAll().subscribe(
      data => {
        this.warehouses = data;
        //  console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerWarehouse() {
    const newWareHouse = new Warehouse();

    newWareHouse.cantidad = this.warehouseForm.value.cantidad;
    newWareHouse.fecha_ingreso = this.warehouseForm.value.fecha_ingreso;
    newWareHouse.precio_compra = this.warehouseForm.value.precio_compra;
    newWareHouse.nro_comprobante = this.warehouseForm.value.nro_comprobante;
    newWareHouse.producto_id = this.warehouseForm.value.producto_id;

    if (this.estado === true) {
      // console.log(newWareHouse);
      this.isLoading = true;

      this.warehouseService
        .update(this.almacen_id, newWareHouse)
        .pipe(
          finalize(() => {
            this.warehouseForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            console.log(data);
            Swal.fire(data);
            // this.listCategories();
            Swal.fire(data);
            this.warehouseForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    } else {
      this.isLoading = true;

      this.warehouseService
        .create(newWareHouse)
        .pipe(
          finalize(() => {
            this.warehouseForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            // console.log(credentials);

            //  this.router.navigate(['/dashboard']);
            Swal.fire(data);
            this.warehouseForm.reset();
            this.activeModal.close(data);
          },
          (error: any) => {
            Swal.fire(`Login error: ${error.error}`);
            //  console.log(`Login error: ${error}`);
          }
        );
    }
  }
}
